import api from './api';

export const fetchTermsService = () =>
  api(`/api/v1/letrus_letrusglobalconfiguration/?search=terms`);

export const fetchServerStatusService = () => api('/api/v1/status');
